import { Map as ImmutableMap } from 'immutable';
import DocumentSummaryRecord from 'documents-ui/records/DocumentSummaryRecord';
import { DOCUMENT_SUMMARY_FETCH_SUCCEEDED, DOCUMENT_SUMMARY_FETCH_FAILED, DOCUMENTS_GDPR_SETTING_FETCH_SUCCEEDED, DOCUMENTS_GDPR_SETTING_FETCH_FAILED, DOCUMENTS_GDPR_SETTING_UPDATE_SUCCEEDED, DOCUMENT_VISITORS_FETCH_STARTED, DOCUMENT_VISITORS_FETCH_SUCCEEDED, DOCUMENT_VISITORS_FETCH_FAILED, DOCUMENT_REVISITS_FETCH_SUCCEEDED, DOCUMENT_UPDATE_SUCCEEDED, DOCUMENT_CHIRP_UPDATE_SUCCEEDED, DOCUMENT_BRAND_UPDATE_SUCCEEDED, REUPLOAD_DOCUMENT_CREATE_SUCCEEDED, REUPLOAD_DOCUMENT_CREATE_FAILED, REUPLOAD_DOCUMENT_CHIRP_CREATE_SUCCEEDED, REUPLOAD_DOCUMENT_CHIRP_CREATE_FAILED, DOCUMENTS_DELETE_SUCCEEDED, DOCUMENTS_CHIRP_REMOVE_SUCCEEDED, REUPLOAD_PROGRESS_PERCENT, REUPLOAD_PROGRESS_PERCENT_CHIRP, DOCUMENTS_GDPR_SETTING_FETCH_CHIRP_SUCCEEDED, DOCUMENTS_GDPR_SETTING_UPDATE_CHIRP_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
const documentSummaryVisitorsInitialState = {
  deckVisitors: null,
  hasMore: true,
  nextOffset: null,
  documentVisitorSearchQuery: '',
  visitorsIsLoading: true,
  visitorsFetchFailure: false
};
const initialState = Object.assign({
  documentsSummary: ImmutableMap(),
  documentsRevisits: ImmutableMap(),
  documentsSummaryError: false,
  documents: ImmutableMap(),
  documentGDPRSettings: {}
}, documentSummaryVisitorsInitialState);
export default ((state = initialState, action) => {
  switch (action.type) {
    case DOCUMENT_SUMMARY_FETCH_SUCCEEDED:
      {
        const documentMetadataRecord = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.update(documentMetadataRecord.get('deckId'), (documentSummaryRecord = DocumentSummaryRecord()) => documentSummaryRecord.set('metadata', documentMetadataRecord))
        });
      }
    case DOCUMENTS_GDPR_SETTING_UPDATE_CHIRP_SUCCEEDED:
    case DOCUMENTS_GDPR_SETTING_FETCH_CHIRP_SUCCEEDED:
      {
        const {
          gdprSettings
        } = action.payload;
        return Object.assign({}, state, {
          documentGDPRSettings: Object.assign({}, state.documentGDPRSettings, {
            // Set gdpr settings for the document
            [gdprSettings.documentId]: gdprSettings
          })
        });
      }
    case DOCUMENTS_GDPR_SETTING_FETCH_SUCCEEDED:
    case DOCUMENTS_GDPR_SETTING_UPDATE_SUCCEEDED:
      {
        const documentGDPRRecord = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.update(documentGDPRRecord.get('deckId'), (documentSummaryRecord = DocumentSummaryRecord()) => documentSummaryRecord.set('gdpr', documentGDPRRecord))
        });
      }
    case DOCUMENT_UPDATE_SUCCEEDED:
      {
        const updatedDocumentData = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([updatedDocumentData.get('id'), 'metadata'], documentMetadataRecord => {
            return documentMetadataRecord === null || documentMetadataRecord === void 0 ? void 0 : documentMetadataRecord.merge({
              title: updatedDocumentData.get('title')
            });
          })
        });
      }
    // TODO: Update this to use new CHIRP documentSummary state slice when we migrate document summary fetch to CHIRP
    case DOCUMENT_CHIRP_UPDATE_SUCCEEDED:
      {
        const {
          id,
          title
        } = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([id, 'metadata'], documentMetadataRecord => {
            return documentMetadataRecord === null || documentMetadataRecord === void 0 ? void 0 : documentMetadataRecord.merge({
              title
            });
          })
        });
      }
    case DOCUMENT_BRAND_UPDATE_SUCCEEDED:
      {
        const {
          documentId,
          brandId
        } = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([documentId, 'metadata'], documentMetadataRecord => {
            return documentMetadataRecord === null || documentMetadataRecord === void 0 ? void 0 : documentMetadataRecord.merge({
              brandId
            });
          })
        });
      }
    case DOCUMENT_VISITORS_FETCH_SUCCEEDED:
      {
        const {
          documentVisitorSearchQuery,
          visitorData
        } = action.payload;
        const deckVisitors = visitorData.get('deckVisitors');
        if (documentVisitorSearchQuery !== state.documentVisitorSearchQuery) {
          return state;
        }
        return Object.assign({}, state, {
          hasMore: visitorData.get('hasMore'),
          nextOffset: visitorData.get('offset'),
          deckVisitors,
          visitorsIsLoading: false
        });
      }
    case DOCUMENT_VISITORS_FETCH_FAILED:
      {
        const {
          documentVisitorSearchQuery
        } = action.payload;
        if (documentVisitorSearchQuery !== state.documentVisitorSearchQuery) {
          return state;
        }
        return Object.assign({}, state, {
          visitorsIsLoading: false,
          visitorsFetchFailure: true
        });
      }
    case REUPLOAD_DOCUMENT_CREATE_SUCCEEDED:
      {
        const reuploadDocumentData = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([reuploadDocumentData.get('id'), 'metadata'], documentMetadataRecord => {
            if (!documentMetadataRecord) {
              return documentMetadataRecord;
            }
            return documentMetadataRecord.merge({
              thumbnailUrl: null,
              progressionPercent: null
            });
          })
        });
      }
    case REUPLOAD_DOCUMENT_CHIRP_CREATE_SUCCEEDED:
      {
        const {
          documentId
        } = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([documentId, 'metadata'], documentMetadataRecord => {
            if (!documentMetadataRecord) {
              return documentMetadataRecord;
            }
            return documentMetadataRecord.merge({
              thumbnailUrl: null,
              progressionPercent: null
            });
          })
        });
      }
    // TODO: Update CHIRP case to use new documentSummary state slice when we migrate document summary fetch to CHIRP
    case DOCUMENTS_DELETE_SUCCEEDED:
    case DOCUMENTS_CHIRP_REMOVE_SUCCEEDED:
      {
        const documentsToDelete = action.payload;
        const updatedDocumentsSummary = documentsToDelete.reduce((_documentsSummary, {
          contentId
        }) => _documentsSummary.remove(contentId), state.documentsSummary);
        return Object.assign({}, state, {
          documentsSummary: updatedDocumentsSummary
        });
      }
    case DOCUMENT_VISITORS_FETCH_STARTED:
      {
        const {
          initial,
          documentVisitorSearchQuery = ''
        } = action.payload;
        if (initial) {
          return Object.assign({}, state, documentSummaryVisitorsInitialState, {
            documentVisitorSearchQuery
          });
        }
        return Object.assign({}, state, {
          visitorsIsLoading: true,
          visitorsFetchFailure: false
        });
      }
    case DOCUMENT_REVISITS_FETCH_SUCCEEDED:
      {
        const {
          deckId,
          vid,
          revisitsData
        } = action.payload;
        return Object.assign({}, state, {
          documentsRevisits: state.documentsRevisits.update(deckId, ImmutableMap(), documentRevisits => documentRevisits.set(vid, revisitsData))
        });
      }
    case REUPLOAD_DOCUMENT_CREATE_FAILED:
    case REUPLOAD_DOCUMENT_CHIRP_CREATE_FAILED:
      {
        const deckId = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([deckId, 'metadata'], documentMetadataRecord => {
            if (!documentMetadataRecord) {
              return documentMetadataRecord;
            }
            return documentMetadataRecord.set('progressionPercent', null);
          })
        });
      }
    case REUPLOAD_PROGRESS_PERCENT:
    case REUPLOAD_PROGRESS_PERCENT_CHIRP:
      {
        const {
          id,
          percent
        } = action.payload;
        return Object.assign({}, state, {
          documentsSummary: state.documentsSummary.updateIn([id, 'metadata'], documentMetadataRecord => {
            if (!documentMetadataRecord) {
              return documentMetadataRecord;
            }
            return documentMetadataRecord.set('progressionPercent', percent);
          })
        });
      }
    case DOCUMENT_SUMMARY_FETCH_FAILED:
    case DOCUMENTS_GDPR_SETTING_FETCH_FAILED:
      return Object.assign({}, state, {
        documentsSummaryError: true
      });
    default:
      return state;
  }
});